import { lazy } from 'react'

import { GetStartedPoliciesDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const GetStartedPage = lazy(() => import('modules/get_started/pages/GetStartedPage'))

export const getStartedRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.getStarted.path,
      element: <GetStartedPage />,
      handle: {
        module: 'get_started',
        meta: ({ watchQuery }) => {
          return watchQuery({
            query: GetStartedPoliciesDocument,
          }).map(() => {
            return {
              title: i18n.t('growth.get_started.sidebar'),
              illustration: 'rocket',
            }
          })
        },
      },
    },
  ]
}
